import { useQuery } from '@tanstack/react-query';

import { getShopWithPointsItems } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const SHOP_WITH_POINTS_PRODUCTS_QUERY_KEY = 'shop-with-points-products';

// CUS-5904. Keep items fresh for 1 hour so they don't change for all PDP visits
const defaultStaleTime = 3600000;

export const selectSortedShopItems = (data) =>
    data?.filter((item) => !item.isGift).sort((a, b) => (a.pointPrice < b.pointPrice ? -1 : 1));

const useShopWithPointsProductsQuery = ({ queryOptions = {} } = {}) => {
    const { data: account = {} } = useAccountQuery();
    const chargeID = account?.nextOrder?.chargeID;

    const query = useQuery({
        queryKey: [SHOP_WITH_POINTS_PRODUCTS_QUERY_KEY, chargeID],
        queryFn: () => getShopWithPointsItems(chargeID),
        select: (response) => {
            if (response.msg === 'Success') {
                return selectSortedShopItems(response.data.items);
            }
            return [];
        },
        enabled: !!chargeID,
        staleTime: defaultStaleTime,
        ...queryOptions,
    });

    return query;
};

export default useShopWithPointsProductsQuery;
